/* Below-the-fold video: nothing downloads until the panel is about a screen away, and it pauses again once it has gone. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      v.bsInView = e.isIntersecting;
      if (e.isIntersecting) {
        if (!v.src) v.src = v.getAttribute('data-bs-lazy-video');
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (v.src) { v.pause(); }
    });
  }, { rootMargin: '800px 0px' }) : null;
  function scan(root) {
    [].forEach.call((root || document).querySelectorAll('video[data-bs-lazy-video]'), function (v) {
      if (io) io.observe(v); else { v.src = v.getAttribute('data-bs-lazy-video'); if (!reduce) v.play(); }
    });
  }
  scan();
  // a browser pauses video in a hidden tab; pick the visible ones back up when the visitor returns
  document.addEventListener('visibilitychange', function () {
    if (document.hidden || reduce) return;
    [].forEach.call(document.querySelectorAll('video[data-bs-lazy-video]'), function (v) {
      if (v.bsInView && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* Financing small print: snippets/bs-price.liquid's 'note' part (representative example + disclosure) is rendered by
   every section that shows a monthly figure, so a long page repeats it many times. Only one needs to stay on the
   page; prefer the copy inside the product buy box (assets/bs-buy.js) when the page has one. */
(function () {
  function dedupe() {
    var notes = [].slice.call(document.querySelectorAll('[data-bs-fin-note]'));
    if (!notes.length) return;
    notes.forEach(function (n) { n.hidden = false; });
    var keep = notes.filter(function (n) { return n.closest('[data-bs-buy]'); })[0] || notes[0];
    notes.forEach(function (n) { n.hidden = (n !== keep); });
  }
  document.addEventListener('DOMContentLoaded', dedupe);
  document.addEventListener('shopify:section:load', dedupe);
})();
